// External booking provider. Patients schedule and book appointments through
// Headway; consultation/booking CTAs across the site link here.
export const BOOKING_URL =
  "https://care.headway.co/providers/robert-holmes?utm_source=pem&utm_medium=direct_link&utm_campaign=90272";
